import Article from '../models/Article';

export default class TagUtils {
	static hasEmptyTag(article: Article): boolean {
		return TagUtils.hasTag(article, 'empty');
	}

	static hasNewTag(article: Article): boolean {
		return TagUtils.hasTag(article, 'new');
	}

	static hasPopularTag(article: Article): boolean {
		return TagUtils.hasTag(article, 'popular');
	}

	static hasTopsellerTag(article: Article): boolean {
		return TagUtils.hasTag(article, 'topseller');
	}

	static hasExtraSlotsTag(article: Article): boolean {
		return TagUtils.hasTag(article, 'extra_slots');
	}

	static hasGlutenFreeTag(article: Article): boolean {
		return TagUtils.hasTag(article, 'glutenfree');
	}
	static hasComboMeals(article: Article): boolean {
		return TagUtils.hasTag(article, 'is_combo_meal');
	}

	static hasTag(article: Article, identifier: string): boolean {
		if (!article || !identifier) {
			return false;
		}
		if (!article.tags) {
			return false;
		}
		if (article.tags.length === 0) {
			return false;
		}
		
		return article.tags.find(tag => tag.identifier === identifier) !== undefined;
	}
}
